import * as React from 'react'

export interface TestSessionPerson {
	subjectId: string
	email: string | null
	displayName: string | null
}

export interface TestSessionBannerProps {
	actor: TestSessionPerson
	target: TestSessionPerson
	expiresAt: string
	endUrl: string
	returnTo: string
	className?: string
}

function personLabel(person: TestSessionPerson): string {
	return person.displayName ?? person.email ?? person.subjectId
}

export function TestSessionBanner({
	actor,
	target,
	expiresAt,
	endUrl,
	returnTo,
	className = '',
}: TestSessionBannerProps) {
	const targetLabel = personLabel(target)
	const actorLabel = personLabel(actor)
	const expiry = new Date(expiresAt)
	const expiryLabel = Number.isNaN(expiry.getTime())
		? null
		: expiry.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })

	return (
		<section
			aria-label="Test Session"
			className={`relative z-[100] border-b-4 border-gold bg-maroon px-4 py-3 text-cream shadow-md ${className}`}
			role="status"
		>
			<div className="mx-auto flex max-w-site flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
				<div className="min-w-0">
					<p className="font-ui text-xs font-bold uppercase tracking-wider text-gold">
						Test Session
					</p>
					<p className="font-ui text-sm font-semibold text-cream">
						Viewing as {targetLabel}
						{target.email && target.displayName ? ` (${target.email})` : ''}
					</p>
					<p className="font-ui text-xs text-cream/80">
						Administrator Session retained for {actorLabel}
						{expiryLabel ? ` · Expires at ${expiryLabel}` : ''}
					</p>
				</div>
				<form action={endUrl} method="post" className="shrink-0">
					<input type="hidden" name="redirectTo" value={returnTo} />
					<button
						type="submit"
						className="inline-flex min-h-10 items-center justify-center rounded-md border border-cream/40 bg-cream px-4 py-2 font-ui text-sm font-semibold text-maroon transition-colors hover:bg-cream-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-maroon"
					>
						End Test Session
					</button>
				</form>
			</div>
		</section>
	)
}
